// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"bb56cda8","31":"a2ac3296","139":"d7ef6598","155":"2fed0a6f","200":"4480ebfc","366":"6f5664d6","412":"cdc9183f","465":"071af365","478":"eeae626e","488":"d504851c","579":"a2a8372f","715":"2105d9ab","829":"1aee652d","886":"ee6ce865","887":"9f1aefd2","905":"3fe1d163"}[chunkId] + ".chunk.js";
};